import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';
import { getIngestionRecord } from 'Workspace/Projects/store/actions';
import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const { ingestionId } = action;
  const workspaceProjectIngestGet = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_PROJECT_INGEST_GET,
    ingestionId,
  });
  if (workspaceProjectIngestGet.type === constants.RTM_PROJECT_INGEST_GET_OK) {
    const ingestionRecord = workspaceProjectIngestGet.response.ingestion;
    yield put(getIngestionRecord(ingestionRecord));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: <FormattedMessage {...messages.failedWorkspaceProjectIngestList} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_PROJECT_INGEST_GET, catchErrors, sendRequest, connection);
}
